import React, { useCallback } from 'react';
import {
	Control,
	FieldValues,
	UseFormSetValue,
	UseFormWatch,
} from 'react-hook-form';

import { Label, ModalSelect, Select } from '@components/common';

import { TSelectOption } from '@interfaces/components/componentTypes';
import { IModalSelectOption, TValueType } from '@components/common/ModalSelect/ModalSelect.types';

import { EParametersFormValues } from '../../enums';

import styles from '../HistoryCheckOptions.module.scss';

interface IHistoryCheckMavenirOptions {
	versionOptions: TSelectOption[];
	nodesOptions: TSelectOption<TValueType>[];
	configTypeOptions: TSelectOption[];
	control: Control;
	watch: UseFormWatch<FieldValues>;
	setValue: UseFormSetValue<FieldValues>;
}

const HistoryCheckMavenirOptions = ({
	versionOptions,
	configTypeOptions,
	control,
	watch,
	setValue,
	nodesOptions,
}: IHistoryCheckMavenirOptions) => {
	const onChangeNodes = useCallback((values: IModalSelectOption[]) => {
		setValue(EParametersFormValues.nodes, values);
	}, [setValue]);

	const isNodesDisabled = !watch(EParametersFormValues.vendor);
	const isVersionDisabled = !watch(EParametersFormValues.nodes)?.length;
	const isConfigTypeDisabled = !watch(EParametersFormValues.version);

	return (
		<>
			<div className={styles.groupOptions}>
				<Label
					className={styles.header}
					label='5G RAN Config'
				/>
			</div>
			<div>
				<Label
					className={styles.sitesLabel}
					label='Nodes'
					required
				/>
				<ModalSelect
					disabled={isNodesDisabled}
					label='Select nodes'
					modalLabel='Select nodes'
					onChange={onChangeNodes}
					options={nodesOptions}
					searchPlaceholder='Search by node ID'
					values={watch(EParametersFormValues.nodes)}
				/>
			</div>
			<div className={styles.groupOptions}>
				<Select
					control={control}
					disabled={isVersionDisabled}
					label='Release version'
					name={EParametersFormValues.version}
					options={versionOptions}
					placeholder='Select release version'
					required
				/>
				<Select
					control={control}
					disabled={isConfigTypeDisabled}
					label='Config type'
					name={EParametersFormValues.configType}
					options={configTypeOptions}
					placeholder='Select config type'
					required
				/>
			</div>
		</>
	);
};

export default HistoryCheckMavenirOptions;
